export default __webpack_public_path__ + "static/06-d700851d5b1841b9cf6b97395078f916.jpg";